import MenuRadio from "components/MenuRadio"
import type React from "react"
import {
  LogoBackground,
  LogoSide,
  type PostGeaState,
  PriceSide,
  Size,
  TitleColor,
} from "../hooks/usePostGeaState"

const sizeOptions = [
  { label: "Post", value: Size.FB },
  { label: "Story", value: Size.Insta },
]
const logoSideOptions = [
  { label: "Logo - Esquerda", value: LogoSide.Left },
  { label: "Logo - Direita", value: LogoSide.Right },
]
const logoBackground = [
  { label: "Logo – fundo transparente", value: LogoBackground.Without },
  { label: "Logo – fundo opaco", value: LogoBackground.With },
]
const priceSideOptions = [
  { label: "Preço - Esquerda", value: PriceSide.Left },
  { label: "Preço - Direita", value: PriceSide.Right },
]
const titleColorOptions = [
  { label: "Cinza", value: TitleColor.Gray },
  { label: "Branco", value: TitleColor.White },
]

type Props = {
  state: PostGeaState
}

const GeaControls: React.FC<Props> = ({ state }) => (
  <div className="w-3/4 my-1 text-center flex flex-col gap-2 p-2 mx-auto">
    <MenuRadio
      selected={state.size}
      options={sizeOptions}
      onClick={state.setSize}
    />
    <MenuRadio
      selected={state.logoSide}
      options={logoSideOptions}
      onClick={state.setLogoSide}
    />
    <MenuRadio
      selected={state.logoBackground}
      options={logoBackground}
      onClick={state.setLogoBackground}
    />
    <MenuRadio
      selected={state.priceSide}
      options={priceSideOptions}
      onClick={state.setPriceSide}
    />
    <MenuRadio
      selected={state.titleColor}
      options={titleColorOptions}
      onClick={state.setTitleColor}
    />
  </div>
)

export default GeaControls
